import React, { useCallback } from 'react';
import { omit } from 'lodash';

import CN from 'components/experiment/PosPage.module.scss';
import MoneyInput from 'components/form/MoneyInput.component';
import S from 'constants/string.const';
import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';

const MoneyPanel = (props) => {
  const { displayDecimals, amount, noNegative } = props;

  const [money, setMoney] = useStateWhileMounted(amount);
  const [ev, setEv] = useStateWhileMounted();

  const handleMoneyBlur = useCallback(
    (ev) => {
      setMoney(ev.value);
      setEv(ev);
    },
    [setEv, setMoney],
  );
  const handleMoneyChange = useCallback(
    (ev) => {
      setMoney(ev.string);
      setEv(ev);
    },
    [setEv, setMoney],
  );

  return (
    <div className={CN.vertical}>
      <div>
        <MoneyInput
          value={money}
          displayDecimals={displayDecimals}
          noNegative={noNegative}
          onBlur={handleMoneyBlur}
          onChange={handleMoneyChange}
        />
        {S.arrowE}
        {String(money)}
      </div>
      {S.arrowNS}
      <div>
        <div>{JSON.stringify(props)}</div>
        {S.arrowE}
        <div>{JSON.stringify(omit(ev, ['event', 'is', 'coin']))}</div>
        <div>{JSON.stringify(ev && ev.is)}</div>
        <div>{JSON.stringify(ev && ev.coin)}</div>
      </div>
    </div>
  );
};

export default MoneyPanel;
